import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-image-with-text-conven-feet-01.js';
import buttonPrimary from '../../ui-modules/button-primary/raw-html';
const btnPrimary = buttonPrimary({
  iconSuffix: {
    show: false,
    src: '',
  },
  text: 'Purchase Now',
  backgroundColor: '#006196',
  color: '#FFFFFF',
  radius: 12,
  policy: {
    show: false,
    colPerView: 0,
    alignContent: 'center',
    items: [],
  },
});
const html = `
<div data-use-custom-width="false" data-custom-width="1204" class="container" data-attribute="container-content"
    style="--custom-width: 1204px;">
    <div data-attribute="wrap-card" data-center-y="true" data-gap-item="112" class="wrap-card"
        style="--gap-item: 112px;">
        <div data-attribute="wrap-content" class="wrap-content" data-order="1" style="--order-content: 1;">
            <div data-attribute="wrap-title" class="wrap-title">
                <h2>OUR STORY</h2>
                <p>
                    <meta charset="utf-8">As a physical therapist of 14 years, I've seen too many patients walk into my
                    clinic <strong>defeated by chronic pain...</strong>
                </p>
                <p><br><strong>After treating over 1,200 patients,</strong> I noticed one devastating pattern: they were
                    spending hundreds of dollars on 'high-end' sneakers and rigid orthotics, only for pain.</p>
                <p><br>When one nurse walked in after a double shift, barely able to stand from heel
                    inflammation,<strong> I tried something different...</strong></p>
                <p><br>I spent months developing a prototype that focused on anatomical freedom. I gave her the first
                    pair of what would become our Breathable Knit Slip-Ons.</p>
                <p><br>Two weeks later, she came back to give me a hug. For the first time in her career, <strong>she
                        wasn't hurting.</strong></p>
                <p><br>She asked if I'd ever consider making these for others. That question changed everything. With
                    over a decade of seeing foot pain destroy people's mobility and confidence, <strong>I realized I
                        could help millions find their 'go' again.</strong></p>
                <p><br>That's when <strong>CONVEN </strong>was created. No bulky boots. No overpriced insoles.&nbsp;</p>
                <p><br><strong>Just something that actually works.&nbsp;</strong></p>
                <p><br>- Dr. Marcus Thorne (Founder)</p>
            </div>
            <div data-attribute="signature-image" data-show="true" class="signature-image">
                <img src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e99e476fd1757e8c66a7.png"
                    alt="">
            </div>
            <div data-attribute="wrap-btn-cta" class="wrap-btn-cta">
                ${btnPrimary}
            </div>
        </div>
        <div data-attribute="wrap-images" class="wrap-images" data-order="2" data-border-image="10"
            data-border-color-image="#006196"
            style="--order-images: 2; --border-image: 10px; --border-color-image: #006196;">
            <div data-attribute="block-images" class="block-images">

                <div class="wrap-image">
                    <img data-attribute="image-item"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e90c5b750c6e7de6a035.png"
                        alt="">
                </div>
                
                
                <div class="wrap-image">
                    <img data-attribute="image-item"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e911bcc94ecf4468ac45.png"
                        alt="">
                </div>

                <div class="wrap-image">
                    <img data-attribute="image-item"
                        src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1e908c1371e88800b5f81.png"
                        alt="">
                </div>
                
                
            </div>
        </div>
    </div>
</div>
`;

export default containerFuild(html, css);
